import styled from "styled-components";

export const PrepaidContent = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  background-color: #f5f6f8;
  flex-direction: column;
`;
export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  padding: 10px 10%;
  ${(props) => props.theme.smartphone} {
    padding: 10px 3%;
  }
`;

export const SubTitle = styled.p`
  font-size: 23px;
  line-height: 30px;
  padding: 20px 16px;
  font-family: "Roboto Regular", sans-serif;
  color: ${(props) => props.theme.tuatara};
  ${(props) => props.theme.smartphone} {
    font-size: 14px;
    line-height: 20px;
    color: ${(props) => props.theme.ironSideGray};
  }
`;

export const GoBack = styled.div`
  display: flex;
  height: 116px;
  width: 100%;
  ${(props) => props.theme.tablet} {
    height: 60px;
  }
`;

export const BackButton = styled.button`
  background-color: transparent;
  border: none;
  outline: none;
  cursor: pointer;
  margin-top: 25px;
  width: 30px;
  ${(props) => props.theme.tablet} {
    margin-top: 20px;
  }
`;

export const BackButtonImage = styled.img`
  height: 26px;
  width: 26px;
  object-fit: contain;
`;

export const Destiny = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  ${(props) => props.theme.tablet} {
    margin-bottom: 32px;
  }
`;

export const ContainerOption = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  list-style: none;
  margin: 60px 0px 90px 0px;
  justify-content: space-between;
  ${(props) => props.theme.smartphone} {
    flex-direction: column;
    margin: 10px 0px 60px 0px;
  }
`;

export const ConfirmFooter = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #ade3f5;
  height: 74px;
  margin-top: 36px;
  bottom: 0;
  position: fixed;
  width: 100%;
  ${(props) => props.theme.smartphone} {
    height: 66px;
  }
`;

export const ConfirmButton = styled.button`
  width: 215px;
  height: 49px;
  background-color: ${(props) => props.theme.white};
  border-radius: 24px;
  border: none;
  color: ${(props) => props.theme.brightTurquoise};
  font-family: Nunito;
  font-size: 17px;
  font-weight: 800;
  outline: none;
  cursor: pointer;

  &:disabled {
    opacity: 0.5;
    cursor: default;
  }
`;
